<template>
  <div id="aoeinvoice" class="aoe-payment-gateway">
    <h5>{{ t('payment.InvoiceHeader') }}</h5>
    <div class="row mt-3">
      <div class="col-12 invoice-payment-entry">
        {{ t('payment.InvoicePaymentEntry', [props.cart?.customerFirstName, props.cart?.customerLastName]) }}
      </div>
    </div>
    <div v-if="props.cart?.invoice?.invoiceNumber != null" class="row mt-3">
      <div class="col-12 col-md-4 invoice-payment-label">
        {{ t('payment.InvoiceNumber') }}:
      </div>
      <div class="col-12 col-md-8 invoice-payment-value">
        {{ props.cart?.invoice?.invoiceNumber }}
      </div>
    </div>
    <div v-if="props.cart?.invoice?.issueDate != null" class="row mt-3">
      <div class="col-12 col-md-4 invoice-payment-label">
        {{ t('payment.InvoiceIssueDate') }}:
      </div>
      <div class="col-12 col-md-8 invoice-payment-value">
        {{ formatDateWithShortMonth(props.cart?.invoice?.issueDate.toString()) }}
      </div>
    </div>
    <div v-if="props.cart?.invoice?.invoiceStatus != null" class="row mt-3">
      <div class="col-12 col-md-4 invoice-payment-label">
        {{ t('payment.InvoiceStatus') }}:
      </div>
      <div class="col-12 col-md-8 invoice-payment-value">
        {{ props.cart?.invoice?.invoiceStatus.localizedValue }}
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 invoice-create-button">
        <KButton
          @click="createInvoiceClickedHandler($event)"
          class="baseBtn primaryBtn payment-invoice-create-button"
          :rounded="'large'"
          :theme-color="'checkoutContinue'">
          {{ props.cart?.invoice?.invoiceNumber != null ? t('payment.ResendInvoiceButton', [props.cart?.customerFirstName, props.cart?.customerLastName]) : t('payment.CreateInvoiceButton', [props.cart?.customerFirstName, props.cart?.customerLastName]) }}
        </KButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
import { onMounted } from 'vue'
import { useLogger } from 'vue-logger-plugin'
import type { IAoeCart } from '@/types/CartTypes.ts'
import { Button as KButton } from '@progress/kendo-vue-buttons'
import { CreateInvoiceCart } from '@/services/CartService.ts'
import { SetIsLoading } from '@/services/AoeHelpers'
import { formatDateWithShortMonth } from "@/api/Common.ts";

const emit = defineEmits(["update-cart"]);

const props = defineProps<{
  cart: IAoeCart | null
}>()

const logger = useLogger()

onMounted(async () => {
  logger.debug('onMounted InvoicePaymentEntry')

  if (props.cart == null) {
    logger.error('props.cart is null')
    return
  }
})

function createInvoiceClickedHandler(event: MouseEvent) {
  logger.debug('createInvoiceClickedHandler', event)

  SetIsLoading(true)
  CreateInvoiceCart({
    aoeCartIdToken: props.cart? props.cart.aoeCartIdToken : ''
  }).then(() => {
    logger.debug('CreateInvoiceCart success')
    if (props.cart?.invoice?.invoiceNumber == null)
    {
      emit("update-cart", event)
    }
    SetIsLoading(false)
  })
}

</script>

<style lang="scss">

</style>
